// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---N8r2P","sk-bouncedelay":"sk-bouncedelay---XU16_","bounce1":"bounce1---VKE2l","bounce2":"bounce2---w3giP"};